module.exports = __webpack_public_path__ + "static/media/catherine.44a6e050.jpg";